/* eslint-disable react/jsx-no-target-blank */
import React from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import Swal from 'sweetalert2'
import Form from "react-bootstrap/Form";
import "./PageLogin.css";
import Logo from "../img//LogoSW.png";
import Navbar from 'react-bootstrap/Navbar';
import bg from "../img/bg.png";
import { Button, Carousel } from 'react-bootstrap';
import side1 from '../img/PublicRelations(1).jpg'
import side2 from '../img/PublicRelations(2).jpg'
import side3 from '../img/PublicRelations(3).jpg'
import side4 from '../img/PublicRelations.jpg'
// import { FaHandMiddleFinger, FaHandPointRight } from "react-icons/fa";

import LineOA from "../components/LineOA";
import { useSearchParams } from "react-router-dom";

const PagePublicRelations = () => {



    return (
        <><Form>
            <div className="App login-box">
                <header className="min-vh-100 d-flex flex-column align-items-center justify-content-center py-4 "
                    // style={{ backgroundColor: "rgb(0, 0, 0, 0.2)", }} 
                    style={{
                        backgroundImage: `url(${bg})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",

                    }}
                >
                    <div className="rounded" style={{ backgroundColor: "rgb(0, 0, 0, 0.2)", margin: "0 15px 0 15px" }} >
                        <div className="px-3 px-lg-5 py-3">
                            <div className="row gx-5 align-items-center justify-content-center" >
                                <div className="d-flex justify-content-center col-12 col-lg-6 col-xl-7" >
                                    <div className="my-4 col-11 col-lg-12 col-lg-4 text-center" >
                                        <div className="rounded text-center mb-2">
                                            <img src={Logo} alt="Profile" className="rounded img-fluid" style={{ maxHeight: "150px" }} />
                                        </div>

                                        <p className="fw-bolder text-dark text-center text-lg-start " style={{ fontSize: '22px' }}>
                                            ระบบทดสอบสมรรถภาพทางกายกำลังพลทหารอากาศ
                                        </p>
                                        <p className="lead fw-normal text-dark-50 text-center text-lg-start" style={{ fontSize: '18px' }}>
                                            เป็นระบบที่ใช้สำหรับในการทดสอบสมรรถภาพร่างกาย พัฒนาโดยศูนย์ซอฟต์แวร์กองทัพอากาศ
                                            ที่จะช่วยอำนวยความสะดวกให้แก่เจ้าหน้าที่กำลังพลของหน่วยและเจ้าหน้าที่ของการจัดการทดสอบร่างกายของกำลังพลทหารอากาศ
                                        </p>

                                        <div>
                                            <div className="mb-1 mt-1 d-flex justify-content-center justify-content-lg-start">
                                                <a className="btn btn-primary btn-block col-11 col-sm-10  col-md-9 col-lg-10" href="https://www.youtube.com/watch?v=uKPTslkosUo" style={{ fontSize: "13px", border: "none", backgroundColor: "#5887CB" }} target="_blank">
                                                    <span>วิดีโอแนะนำการทดสอบสมรรถภาพทางกาย </span><span className="btn-blink" style={{ fontWeight: "bold" }}>คลิก!</span>
                                                </a>



                                            </div>
                                            <div className="d-flex justify-content-center justify-content-lg-start">
                                                <a className="btn btn-primary btn-lg btn-block col-11 col-sm-10  col-md-9 col-lg-10" href="/PageLogin" style={{ fontSize: "13px", border: "none", backgroundColor: "#003481" }}
                                                >
                                                    คลิกเพื่อเข้าสู่ระบบ
                                                </a>
                                            </div>

                                        </div>

                                    </div>



                                </div>
                                <div className="col-11 col-lg-6 col-xl-5 d-lg-block text-center mb-0" >
                                    <Carousel controls interval={1500} className="mx-auto" style={{ height: '100%', width: '100%' }}>
                                        <Carousel.Item>
                                            <img
                                                className="d-block w-100 rounded "
                                                src={side4}
                                                alt="Slide 1"
                                            />
                                        </Carousel.Item>
                                        <Carousel.Item>
                                            <img
                                                className="d-block w-100 rounded "
                                                src={side1}
                                                alt="Slide 1"
                                            />
                                        </Carousel.Item>
                                        <Carousel.Item>
                                            <img
                                                className="d-block w-100 rounded"
                                                src={side2}
                                                alt="Slide 2"
                                            />
                                        </Carousel.Item>
                                        <Carousel.Item>
                                            <img
                                                className="d-block w-100 rounded"
                                                src={side3}
                                                alt="Slide 3"
                                            />
                                        </Carousel.Item>


                                    </Carousel>


                                </div>


                            </div>
                        </div>
                        <Navbar className="" style={{ backgroundColor: "rgb(102, 102, 153, 0.90)", height: "40px", borderBottomLeftRadius: "8px", borderBottomRightRadius: "8px" }} >
                            <Navbar.Text className="mx-auto text-center" style={{ color: "black", fontSize: "15px", fontFamily: 'Noto Sans Thai' }}>
                                <b><img src={Logo} alt="Profile" className="rounded img-fluid " style={{ maxHeight: "25px" }} /> ศูนย์ซอฟต์แวร์กองทัพอากาศ</b>




                            </Navbar.Text>
                        </Navbar>
                    </div>

                </header>

            </div>

        </Form>
        </>
    )
}

export default PagePublicRelations